import { ViewMode } from '@40seas/entities/common';
import { ComponentType } from 'react';
import { ResourceProps } from 'react-admin';

export enum Resources {
    Account = 'account',
    Buyers = 'buyers',
    CreditLineDashboard = 'creditline-dashboard',
    CreditLine = 'creditline',
    CreditReviews = 'credit-reviews',
    CreditManagement = 'buyers/credit-reviews',
    CreditMonitoring = 'credit-monitoring',
    CreditLineRequest = 'creditline/requests',
    Checkout = 'checkout',
    SearchPlaces = 'search/places',
    Orders = 'orders',
    Invoices = 'invoices',
    Intents = 'intents',
    Shipping = 'shipping',
    Payouts = 'payouts',
    PayoutsCurrencyExchange = 'payouts/currency-exchange',
    PayoutsWithdrawal = 'payouts/withdrawal',
    FeeDefinitions = 'fees', // TODO: change to fee-definitions
    Fees = 'fees/entity', // TODO: change to fees
    Billings = 'billings',
    Leads = 'leads',
    Underwriting = 'underwriting',
    Comments = 'comments',
    Noble = 'noble',
    NobleCustomers = 'noble/customers',
    NobleWorkflows = 'noble/workflows',
    Ocr = 'invoices/ocr',
    Contacts = 'contacts',
    Charges = 'charges',
    Funds = 'funds',
    NotificationDefinitions = 'notifications/definitions',
    NotificationDefinitionsEventType = 'notifications/definitions/event-type',
    UserNotificationSettings = 'notifications/user-settings',
    UserNotificationCustomizations = 'notifications/user-customizations',
    Refunds = 'refunds',
    Allianz = 'allianz',
    Atradius = 'atradius',
    AtradiusCovers = 'atradius/covers',
    Reconciliation = 'reconciliation',
    ChargesReconciliation = 'charges/reconciliation',
    RefundsReconciliation = 'refunds/reconciliation',
    Invites = 'invites',
    InvitesBuyers = 'invites/buyers',
    InvitesSuppliers = 'invites/suppliers',
    Referrals = 'referrals',
    AllianzCompanies = 'allianz/companies',
    AtradiusCompanies = 'atradius/companies',
    AtradiusCoverRequests = 'atradius/cover-requests',
    AllianzCoverRequests = 'allianz/cover-requests',
    AllianzCovers = 'allianz/covers',
    Wise = 'wise',
    WiseRecipients = 'wise/recipients',
    WiseTransfers = 'wise/transfers',
    WiseFundsMatching = 'wise/funds-matching',
    HeronCompanies = 'heron/companies',
    HeronReports = 'heron/reports',
    StripeCustomers = 'stripe/customers',
    WebooksApplications = 'webhooks/applications',
    Webhooks = 'webhooks',
    BankAccount = 'bank-account',
    Recipients = 'recipients',
    Transactions = 'transactions',
    Balances = 'balances',
    Files = 'files',
    PaymentMethods = 'payment-methods',
    FinancialConnections = 'financial-connections',
    Ownership = 'ownership',
    BankTransactions = 'bank-transactions',
    Banktransactions = 'bankTransactions',
    Organizations = 'organizations',
    FeatureToggles = 'feature-toggles',
    organizationsBusinesses = 'organizations/businesses',
    Businesses = 'businesses',
    organizationsPermissions = 'organizations/permissions',
    AuthPermisions = 'auth/permissions',
    AuthRoles = 'auth/roles',
    AuthApplications = 'auth/applications',
    UsersSettings = 'users/settings',
    UsersSettingsContacts = 'users/settings/contacts',
    Experian = 'experian',
    AiprizeCompanies = 'aiprize/companies',
    Plaid = 'plaid',
    WiserfundingCompanies = 'wiserfunding/companies',
    UserConsents = 'user-consents',
    Users = 'users',
    UsersSuppliers = 'users/suppliers',
    UsersBuyers = 'users/buyers',
    FinancialConnectionRefreshRequests = 'financial-connection-refresh-requests',
    Audits = 'audits',
    Suppliers = 'sellers',
    SuppliersView = 'suppliers-view',
    ScheduledTransactionSettings = 'transactions/scheduled-settings',
    BusinessVerification = 'business-verification',
    GocardlessCustomers = 'gocardless',
    Attachments = 'attachments',
    Configs = 'configs',
    Tenants = 'tenants',
    Sync = 'sync',
    LinkedEntities = 'linked-entities',
    Emails = 'emails',
    Codat = 'codat',
    CodatCompanies = 'codat/companies',
    CodatCompanyRefreshes = 'codat/company-refreshes',
    CodatCompanyRefreshRequests = 'codat-company-refresh-requests',
    Rutter = 'rutter',
    RutterCompanies = 'rutter/companies',
    OdooCompanies = 'odoo/companies',
    RutterJobs = 'rutter/jobs',
    RutterValidations = 'rutter/validations',
    ExternalEntities = 'external',
    ExternalBuyers = 'external/buyers',
    ExternalInvoices = 'external/invoices',
    ExternalItems = 'external/items',
    ExternalExpenses = 'external/expenses',
    ExternalPayments = 'external/payments',
    BuyersOwnership = 'buyers/ownership',
    RequestLogs = 'request-logs',
    Airwallex = 'airwallex',
    AirwallexIntents = 'airwallex/intents',
    AirwallexCustomers = 'airwallex/customers',
    AirwallexRecipients = 'airwallex/recipients',
    AirwallexGlobalAccounts = 'airwallex/global-accounts',
    AirwallexTransfers = 'airwallex/transfers',
    AirwallexFundsMatching = 'airwallex/funds-matching',
    ConnectedAccount = 'connected-accounts',
    ConnectedAccounts = 'connected-accounts/accounts',
    ConnectedAccountsBalances = 'connected-accounts/accounts/balances',
    ConnectedAccountsFunds = 'connected-accounts/funds',
    ConnectedAccountsCharges = 'connected-accounts/charges',
    ConnectedAccountsActivities = 'connected-accounts/activities',
    ConnectedAccountsCurrencyConversion = 'connected-accounts/currency-conversion',
    Quotes = 'currency-exchanges/quotes',
    ErpSync = 'erp-sync',
    ErpConfig = 'erp-sync/config',
    Export = 'export',
    CurrencyConversions = 'currency-exchanges/conversions',
    CurrencyExchanges = 'currency-exchanges',
    Reports = 'reports',
    AssistantAgents = 'assistant',
    AssistantThreads = 'assistant/threads',
    AssistantMessages = 'assistant/messages',
    CreditSafeCompanies = 'credit-safe/companies',
    CreditSafeReports = 'credit-safe/reports',
    CreditSafePortfolios = 'credit-safe/portfolios',
    AiKyb = 'ai-kyb',
    CreditReferences = 'credit-references',
    CreditRequirements = 'credit-requirements',
    InsuranceApplication = 'insurance/application',
    Insurance = 'insurance',
    BuyerInsurance = 'buyers/insurance',
    Identities = 'identities',
    IdentitiesDecisions = 'identities/decisions',
    IdentityVerification = 'identity-verification',
    ReminderDefinitions = 'reminders',
    CreditReviewNotes = 'credit-reviews/notes',
    InsuranceCompanies = 'insurance/companies',
    InsuranceCoverRequests = 'insurance/cover-requests',
    InsuranceCovers = 'insurance/covers',
    Timelines = 'timelines',
    Statements = 'statements',
}

export enum InnerResources {
    BuyersContacts = 'buyers/:id/contacts',
    BuyerUsers = 'buyers/:id/users',
    BuyersInstances = 'buyers/:id/instances',
    OrganizationTenants = 'organizations/:id/tenants',
    Ownership = 'financial-connections/:id/ownership',
    Balances = 'financial-connections/:id/balances',
    FinancialConnectionDocuments = 'financial-connections/:id/documents',
    FinancialConnectionOrdersHistory = 'financial-connections/:id/orders-history',
    BankTransactions = 'financial-connections/:id/bank-transactions',
    FinancialConnectionRefreshRequests = 'financial-connections/:id/financial-connection-refresh-requests',
    CreditSafePortfolioCompanies = 'credit-safe/portfolios/:id/companies',
    CreditSafePortfolioEventRules = 'credit-safe/portfolios/:id/event-rules',
    CreditSafePortfolioEvents = 'credit-safe/portfolios/:id/events',
}

export const getInnerResource = (innerResources: InnerResources, id: string) => {
    return innerResources.replace(':id', id);
};

export type ResourcesDefinitionsType = ResourceProps & {
    label: string;
    viewModes?: ViewMode[];
    export?: ComponentType<any>;
};
